import React, { Component } from 'react'
import {connect} from 'react-redux'
import PropTypes from "prop-types";

const blank = (value) => {
  return (value !== undefined)? value: ''
}

const DatetoHtml = (date, result) => {
  if (date === undefined){
    return (result)
  } else {
    const day = date.split('/')[0]
    const month = date.split('/')[1]
    const year = date.split('/')[2]
    const finalDate = month+'-'+day+'-'+year


    const mDate = new Date(finalDate)
    const y = mDate.getFullYear()
    const m = mDate.getMonth() + 1
    const d = mDate.getDate()
    
    return (
      d + '/' + m + '/' + y
    )
  }
}

const findIndex = (values, val) => {
  if (val !== undefined){
    for (let i = 0; i < values.length; i++) {
      if (values[i].value === val) return values[i].name
    }
  }
  return undefined
}

class panelPassangers extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].dataresume
    const langNames = languages[langUrl].dataresume.names
    const {locations, sexes, countries} = languages[langUrl]

    const {index, name} = this.props
    const key = (this.props.name + this.props.index).toLowerCase()
    const values = (this.props.data[key] !== undefined)?this.props.data[key]: {}

    return (
      <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12 resume-panel'>
        <div className='cuadre-height cuadre-principal'>
          <div className='cuadre-title'>{langPlace.passenger}</div>
          <div className='cuadre-subtitle'>{`${langPlace[name]} #${index}`}</div>
        </div>

        <div className='cuadre-height cuadre-transparent'>
          <div className='cuadre-title'>{langNames.namesurname}</div>
          <div className='cuadre-subtitle'>{`${blank(values.name)} ${blank(values.surname)} ${blank(values.secondSurname)}`}</div>
        </div>
        <div className='col-md-6 no-padding'>
          <div className='cuadre-height cuadre-transparent'>
            <div className='cuadre-title'>{langNames.nationality}</div>
            <div className='cuadre-subtitle'>{findIndex(countries, values.nationality)}</div>
          </div>
        </div>
        <div className='col-md-6 no-padding'>
          <div className='cuadre-height cuadre-transparent'>
            <div className='cuadre-title'>{langNames.numberDocument}</div>
            <div className='cuadre-subtitle'>{values.numberDocument}</div>
          </div>
        </div>
        <div className='col-md-6 no-padding'>
          <div className='cuadre-height cuadre-transparent'>
            <div className='cuadre-title'>{langNames.birthDate2}</div>
            <div className='cuadre-subtitle'>{DatetoHtml(values.birthDate, '')}</div>
          </div>
        </div>
        <div className='col-md-6 no-padding'>
          <div className='cuadre-height cuadre-transparent'>
            <div className='cuadre-title'>{langNames.gender}</div>
            <div className='cuadre-subtitle'>{findIndex(sexes, values.gender)}</div>
          </div>
        </div>
        {(this.props.name === 'baby')?
          <div className='cuadre-height cuadre-transparent'/>
        :
        (this.props.data.values.travel === 0)?
          <div>
            <div className='col-md-6 no-padding'>
              <div className='cuadre-height cuadre-transparent'>
                <div className='cuadre-title'>{langNames.locationGone}</div>
                <div className='cuadre-subtitle'>{findIndex(locations, values.locationGone)}</div>
              </div>
            </div>
            <div className='col-md-6 no-padding'>
              <div className='cuadre-height cuadre-transparent'>
                <div className='cuadre-title'>{langNames.locationReturn}</div>
                <div className='cuadre-subtitle'>{findIndex(locations, values.locationReturn)}</div>
              </div>
            </div>
          </div>
        :
          <div className='col-md-12 no-padding'>
            <div className='cuadre-height cuadre-transparent'>
              <div className='cuadre-title'>{langNames.locationGone}</div>
              <div className='cuadre-subtitle'>{findIndex(locations, values.locationGone)}</div>
            </div>
          </div>
        }

      </div>
    )
  }
}

export default connect(
  (state) => ({settings: state.settings, data: state.data})
)(panelPassangers)



// WEBPACK FOOTER //
// ./src/shared/routes/routeResume/components/panelPassangers.js